import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Charged (fed-die): feed a die =6 to
 * add a charge (cap 3); each opponent block-gain consumes a charge and is
 * reduced by 4. */
export const SPIKE_WALL: Card = {
  id: 'spike-wall',
  name: 'Spike Wall',
  type: 'trap',
  rarity: 'rare',
  size: { w: 1, h: 2 },
  cost: [{ kind: 'exact', value: 6 }],
  effects: [
    { kind: 'armOrCharge', amount: 1 },
    { kind: 'reduceBlock', amount: 4 },
  ],
  trap: { variant: 'charged', trigger: { kind: 'opponentBlocks' }, chargeMax: 3 },
};
